import { EButtonLocation, IWorkflowScreenSettings } from "@kuika/kuika-cl-model";
import React from "react";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSmallMediumText from "../../ui-kit/typography/SmallMediumText/SmallMediumText";
import KuikaTextMedium from "../../ui-kit/typography/TextMedium/TextMedium";
import "./step-screen-form-wizard-settings-tab.scss";

export interface IStepScreenFormWizardSettingsTabProps {
  workflowScreensSettings: IWorkflowScreenSettings;
  updateWorkflowScreensSettings: (settings: IWorkflowScreenSettings) => void;
}

export interface IStepScreenFormWizardSettingsTabState {}

/** Where the generated screens put the buttons that move the process along. */
const BUTTON_LOCATION_OPTIONS: KuikaSelectboxOption[] = [
  { value: EButtonLocation.UnderForm, label: "Under Form" },
  { value: EButtonLocation.Top, label: "Top" },
  { value: EButtonLocation.Bottom, label: "Bottom" }
];

class StepScreenFormWizardSettingsTab extends React.PureComponent<
  IStepScreenFormWizardSettingsTabProps & IWithSDProps,
  IStepScreenFormWizardSettingsTabState
> {
  constructor(props: IStepScreenFormWizardSettingsTabProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  onChangeLocation = (value: string | number | null) => {
    if (value === null) {
      return;
    }

    const settings = { ...this.props.workflowScreensSettings, buttonLocation: value as EButtonLocation };
    this.props.updateWorkflowScreensSettings(settings);
  };

  render() {
    return (
      <div className="ssfw-body">
        <div className="kuika-step-screen-settings">
          <div className="kuika-step-screen-settings__field">
            <KuikaTextMedium className="kuika-step-screen-settings__label">Button location</KuikaTextMedium>
            <KuikaSmallMediumText className="kuika-step-screen-settings__hint">
              Configure the location of the Resume Process and/or User Interaction buttons on the screen.
            </KuikaSmallMediumText>
            <KuikaSelectbox
              value={this.props.workflowScreensSettings.buttonLocation}
              options={BUTTON_LOCATION_OPTIONS}
              onChange={this.onChangeLocation}
              placeholder="Choose Location"
              data-testid="workflowScreensButtonLocation"
            />
          </div>
        </div>
      </div>
    );
  }
}

const stepScreenFormWizardSettingsTab = withSD<IStepScreenFormWizardSettingsTabProps>(StepScreenFormWizardSettingsTab);
export { stepScreenFormWizardSettingsTab as StepScreenFormWizardSettingsTab };
